import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
  utilityHeader,
} from 'core/HeaderColTypeProps'
import * as R from 'ramda'
import numeral from 'numeral'
const {
  numCol,
  strCol,
  intCol,
  dateTimeCol,
} = require('@integec/grid-tools/lib/cols')

export const title = 'Net Capacity Verification'
export const HeaderRowHeightVerification = 60
export const max4digit = 9999.99
const max3digit = 999.99
const max2digit = 99.99
const max1digit = 9.99
const width = 150
export const MisoVerificationTestHeaders = [
  // strCol({ ident: 'utility', display: 'Utility', isFiltered: true }),
  utilityHeader,
  unitIdHeader,
  // strCol({ ident: 'unit', display: 'Unit', isFiltered: true }),
  intCol({ ident: 'year', display: 'Year', isFiltered: true }),
  strCol({ ident: 'period', display: 'Period', isFiltered: true }),
  intCol({ ident: 'testIdx', display: 'Test Index', isFiltered: true }),
  strCol({ ident: 'unitType', display: 'Unit Type', isFiltered: true }),
  // strCol({ ident: 'standard', display: 'Standard', isFiltered: true }),
  // numCol({
  //   ident: 'correctedNet',
  //   display: 'Corrected Net',
  //   isFiltered: true,
  //   max: max4digit,
  // }),
  numCol({
    ident: 'correctedNetSummer',
    display: 'Summer Corrected Net',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'correctedNetFall',
    display: 'Fall Corrected Net',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'correctedNetWinter',
    display: 'Winter Corrected Net',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'correctedNetSpring',
    display: 'Spring Corrected Net',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  // numCol({
  //   ident: 'claimedInstalled',
  //   display: 'Claimed Installed',
  //   isFiltered: true,
  //   max: max4digit,
  // }),
  // numCol({
  //   ident: 'difference',
  //   display: 'Difference',
  //   isFiltered: true,
  //   max: max4digit,
  // }),

  dateTimeCol({
    ident: 'testStartDate',
    display: 'Test Start Date',
    isFiltered: true,
    width: 150,
  }),
  dateTimeCol({
    ident: 'testEndDate',
    display: 'Test End Date',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'grossMW',
    display: 'Gross MW',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'stationService',
    display: 'Station Service',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'processLoadServed',
    display: 'Process Load Served',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'netTestCapability',
    display: 'Net Test Capability',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'reactiveGenMvar',
    display: 'Reactive Generation MVAR',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'totalPowerMva',
    display: 'Total Power MVA',
    isFiltered: true,
    max: max4digit,
    width,
  }),
  numCol({
    ident: 'powerFactor',
    display: 'Power Factor',
    isFiltered: true,
    max: max1digit,
    width,
  }),
  numCol({
    ident: 'dryairTempObserved',
    display: 'Dry Air Temperature Observed',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'dryairTempRated',
    display: 'Dry Air Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'dryairTempRatedSummer',
    display: 'Summer Dry Air Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'dryairTempRatedFall',
    display: 'Fall Dry Air Temperature Rated',
    isFiltered: true,
    width,
  }),
  numCol({
    ident: 'dryairTempRatedWinter',
    display: 'Winter Dry Air Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'dryairTempRatedSpring',
    display: 'Spring Dry Air Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'airTempMwCorr',
    display: 'Air Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'airTempMwCorrSummer',
    display: 'Summer Air Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'airTempMwCorrFall',
    display: 'Fall Air Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'airTempMwCorrWinter',
    display: 'Winter Air Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'airTempMwCorrSpring',
    display: 'Spring Air Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityObserved',
    display: 'Relative Humidity Observed',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityRated',
    display: 'Relative Humidity Rated',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityRatedSummer',
    display: 'Summer Relative Humidity Rated',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityRatedFall',
    display: 'Fall Relative Humidity Rated',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityRatedWinter',
    display: 'Winter Air Relative Humidity Rated',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityRatedSpring',
    display: 'Spring Relative Humidity Rated',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityMwCorr',
    display: 'Relative Humidity Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityMwCorrSummer',
    display: 'Summer Relative Humidity Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityMwCorrFall',
    display: 'Fall Relative Humidity Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityMwCorrWinter',
    display: 'Winter Air Relative Humidity Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'relHumidityMwCorrSpring',
    display: 'Spring Relative Humidity Correction',
    isFiltered: true,
    max: max2digit,
    width,
  }),
  numCol({
    ident: 'cwaterTempObserved',
    display: 'Cooling Water Temperature Observed',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'cwaterTempRated',
    display: 'Cooling Water Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width,
  }),
  numCol({
    ident: 'cwaterTempRatedSummer',
    display: 'Summer Cooling Water Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempRatedFall',
    display: 'Fall Cooling Water Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempRatedWinter',
    display: 'Winter Air Cooling Water Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempRatedSpring',
    display: 'Spring Cooling Water Temperature Rated',
    isFiltered: true,
    max: max3digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempMwCorr',
    display: 'Cooling Water Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempMwCorrSummer',
    display: 'Summer Cooling Water Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempMwCorrFall',
    display: 'Fall Cooling Water Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempMwCorrWinter',
    display: 'Winter Air Cooling Water Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width: 200,
  }),
  numCol({
    ident: 'cwaterTempMwCorrSpring',
    display: 'Spring Cooling Water Temperature Correction',
    isFiltered: true,
    max: max2digit,
    width: 200,
  }),

  // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
  strCol({
    ident: 'note',
    display: 'Note',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 300,
  }),
  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, width: d.width || 200 }))

export const MisoVerificationTestHeadersNumberMap = R.compose(
  R.fromPairs,
  R.map(({ ident, max = max4digit }) => [ident, max]),
  R.filter(f => f.type === 'num')
)(MisoVerificationTestHeaders)

const getFloatValue = value => {
  if (isNaN(value)) return 0
  else return parseFloat(value)
}

// this is for  main screen
export const updateDataMain = ({ key, value, data, setData }) => {
  let prepData = { ...data, [key]: value }

  // for net test capcity :  doSubstractNetTestCapability
  let netTestCapability = data.netTestCapability
  if (
    key === 'grossMW' ||
    key === 'stationService' ||
    key === 'processLoadServed'
  ) {
    netTestCapability =
      getFloatValue(prepData.grossMW) -
      getFloatValue(prepData.stationService) -
      getFloatValue(prepData.processLoadServed)
    if (isNaN(netTestCapability)) netTestCapability = 0
    prepData = { ...prepData, netTestCapability }
  }

  // for sqrt : doSqrt(grossJTF, reactiveGMJTF, totalPMJTF) & doDividePowerFactor
  if (key === 'grossMW' || key === 'reactiveGenMvar') {
    const grossVal = getFloatValue(prepData.grossMW)
    const reaGen = getFloatValue(prepData.reactiveGenMvar)
    if (grossVal > 0 && reaGen > 0) {
      let totalPowerMva = Math.sqrt(grossVal * grossVal + reaGen * reaGen)
      totalPowerMva = numeral(numeral(totalPowerMva).format('0.0')).value()
      let powerFactor = 0
      if (totalPowerMva !== 0.0) {
        powerFactor = grossVal / totalPowerMva
        powerFactor = numeral(numeral(powerFactor).format('0.0000')).value()
      }

      prepData = { ...prepData, totalPowerMva, powerFactor }
    }
  }

  const dry = getFloatValue(prepData.airTempMwCorrSummer)
  const rel = getFloatValue(prepData.relHumidityMwCorrSummer)
  const cwater = getFloatValue(prepData.cwaterTempMwCorrSummer)
  const netTestCap = getFloatValue(prepData.netTestCapability)

  const correctedNetSummer = dry + rel + cwater + netTestCap
  prepData = { ...prepData, correctedNetSummer }
  // }

  // for doSubstractDifference
  // mathod is empty

  const calcData = calculateUCAP(prepData)
  setData({ ...prepData, ...calcData })
}

// eslint-disable-next-line no-unused-vars
export const calculateUCAP = curData => {
  const extData = curData.extendedData || {}
  const netTestCapability = getFloatValue(curData.netTestCapability)
  const airTempMwCorr = getFloatValue(curData.airTempMwCorr)
  const cwaterTempMwCorr = getFloatValue(curData.cwaterTempMwCorr)
  const relHumidityMwCorr = getFloatValue(curData.relHumidityMwCorr)

  const xeford = getFloatValue(extData.xeford)

  const total =
    netTestCapability + airTempMwCorr + cwaterTempMwCorr + relHumidityMwCorr

  let ucapJTF = 0
  try {
    ucapJTF = (1 - xeford / 100) * total
  } catch (error) {
    console.log({ xeford, total })
    console.log(error)
  }

  return { ucapJTF }
}

// this is for history
export const updateDataRecord = ({ key, value, data, setData }) => {
  // if (disabled) return
  let prepData = { ...data, [key]: value }

  // for net test capcity :  doSubstractNetTestCapability
  let netTestCapability = data.netTestCapability
  if (key === 'correctedNet' || key === 'claimedInstalled') {
    const correctedNet = getFloatValue(prepData.correctedNet)
    const claimedInstalled = getFloatValue(prepData.claimedInstalled)
    prepData = { ...prepData, difference: correctedNet - claimedInstalled }
  }
  if (
    key === 'grossMW' ||
    key === 'stationService' ||
    key === 'processLoadServed'
  ) {
    netTestCapability =
      getFloatValue(prepData.grossMW) -
      getFloatValue(prepData.stationService) -
      getFloatValue(prepData.processLoadServed)
    if (isNaN(netTestCapability)) netTestCapability = 0
    prepData = { ...prepData, netTestCapability }
  }

  // for sqrt : doSqrt(grossJTF, reactiveGMJTF, totalPMJTF) & doDividePowerFactor
  // if (key === 'grossMW' || key === 'reactiveGenMvar') {
  //   const grossVal = getFloatValue(prepData.grossMW)
  //   const reaGen = getFloatValue(prepData.reactiveGenMvar)
  //   if (grossVal > 0 && reaGen > 0) {
  //     const totalPowerMva = Math.sqrt(grossVal * grossVal + reaGen * reaGen)
  //     // maxFrac = 1 ,
  //     const powerFactor = grossVal / totalPowerMva
  //     // maxFrac = 4 ,
  //     prepData = { ...prepData, totalPowerMva, powerFactor }
  //   }
  // }
  const grossVal = getFloatValue(prepData.grossMW)
  const reaGen = getFloatValue(prepData.reactiveGenMvar)
  if (grossVal > 0 && reaGen > 0) {
    let totalPowerMva = Math.sqrt(grossVal * grossVal + reaGen * reaGen)
    totalPowerMva = numeral(numeral(totalPowerMva).format('0.0')).value()
    let powerFactor = 0
    if (totalPowerMva !== 0.0) {
      powerFactor = grossVal / totalPowerMva
      powerFactor = numeral(numeral(powerFactor).format('0.0000')).value()
    }

    prepData = { ...prepData, totalPowerMva, powerFactor }
  }

  // for doAddCorrectNetTestCapability
  if (
    key === 'dryairTempRatedSummer' ||
    key === 'relHumidityMwCorrSummer' ||
    key === 'cwaterTempMwCorrSummer' ||
    key === 'netTestCapability'
  ) {
    // maxFrac = 1 ,
    const dry = getFloatValue(prepData.dryairTempRatedSummer)
    const rel = getFloatValue(prepData.relHumidityMwCorrSummer)
    const cwater = getFloatValue(prepData.cwaterTempMwCorrSummer)
    const netTestCap = getFloatValue(prepData.netTestCapability)
    const correctedNetSummer = dry + rel + cwater + netTestCap
    prepData = { ...prepData, correctedNetSummer }
  }

  // for doSubstractDifference
  // mathod is empty

  // const calUcal=calculateUCAP(prepData,xefordData)
  setData(prepData)
}
